// extracted by mini-css-extract-plugin
export default {"actionMenu":"styles_actionMenu__8Pfk0"};